import tw from "tailwind-styled-components";

export const ContainerLogin = tw.div`
w-full rounded-md
max-w-full sm:max-w-[80vw] md:max-w-[60vw] lg:max-w-[40vw] xl:max-w-[30vw]
flex flex-col justify-center gap-4 m-auto py-6
bg-transparent
transition-colors duration-300
`;

export const ComponentTitle = tw.p`
font-Outfit font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl
text-center text-primary-500
max-w-[95%] sm:max-w-[90%] md:max-w-[80%] lg:max-w-[70%] mx-auto
`;

export const ComponentIcon = tw.div`
flex justify-center items-center
`;

export const ContainerForm = tw.div`
flex flex-col gap-1
px-2 sm:px-4 md:px-8 lg:px-10
`;

export const Form = tw.form`
flex flex-col gap-4
`;

export const ContainerLabelInput = tw.div`
flex flex-col gap-2
`;

export const Label = tw.label`
text-sm font-medium text-content
transition-colors duration-300
`;

export const ContainerInput = tw.div`
flex flex-col w-full gap-1
`;

export const Input = tw.input`
border border-line focus:outline-none
rounded-lg min-h-10 py-2 px-4
text-sm
bg-card text-content
placeholder-content-faint
transition-colors duration-300
${(props) =>
  props.styleprop
    ? "border-error focus:border-error"
    : "hover:border-primary-500 focus:border-primary-500"}
`;

export const ContainerInputPassword = tw.div`
border border-line focus:outline-none
flex gap-1 rounded-lg min-h-10 pr-3 items-center pl-4
bg-card
transition-colors duration-300
${(props) =>
  props.styleprop
    ? "border-error focus:border-error"
    : "hover:border-primary-500 focus:border-primary-500"}
`;

export const InputPassword = tw.input`
w-full focus:outline-none py-2 text-sm
bg-transparent text-content
placeholder-content-faint
transition-colors duration-300
`;

export const EyeButton = tw.button`
flex items-center justify-center
`;

export const Errors = tw.p`
text-[11px] text-error mt-1
`;

export const ContainerButtons = tw.div`
flex flex-col gap-3 items-center w-full mt-1
`;

export const LinkButton = tw.button`
text-xs font-medium text-primary-500 hover:underline
`;

export const ContainerSwitch = tw.div`
w-full flex items-center justify-center
`;

export const Switch = tw.label`
relative inline-flex items-center cursor-pointer
`;

export const Language = tw.span`
ms-3 text-xs sm:text-sm font-bold text-content
transition-colors duration-300
`;

export const ModalOverlay = tw.div`
fixed inset-0 bg-black/50 flex items-center justify-center z-50
transition-opacity duration-300
`;

export const ModalContent = tw.div`
bg-card border border-line rounded-xl shadow-2xl
w-full max-w-[90vw] sm:max-w-md p-6 sm:p-8
transition-colors duration-300
`;

export const ModalTitle = tw.h2`
text-xl sm:text-2xl font-bold text-content
text-center mb-2
`;

export const ModalDescription = tw.p`
text-sm sm:text-base text-content-muted
text-center mb-6
`;

export const ModalButtonsContainer = tw.div`
flex flex-col gap-3 mt-6
`;

export const BackButton = tw.button`
text-sm font-medium text-content-muted
hover:text-primary-500 transition-colors duration-200
`;
